/**
 * Availability alert requests.
 * Requests are queued in localStorage and sent to the sourcing team through a
 * prepared email. The site does not automatically monitor stock.
 */
(function () {
  if (window.icsAvailabilityAlertsAttached) return;
  window.icsAvailabilityAlertsAttached = true;

  const STORAGE_KEY = "ics_alert_requests";

  function readRequests() {
    try {
      const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function writeRequests(requests) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(requests));
    } catch (error) {
      // Storage unavailable: keep the in-memory session working.
    }
  }

  const form = document.querySelector("[data-alert-form]");
  const status = document.querySelector("[data-alert-status]");
  const list = document.querySelector("[data-alert-list]");
  const empty = document.querySelector("[data-alert-empty]");
  const clearButton = document.querySelector("[data-alert-clear]");

  function escapeHtml(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function showStatus(message, isError) {
    if (!status) return;
    status.textContent = message;
    status.hidden = false;
    if (isError) {
      status.setAttribute("data-error", "true");
    } else {
      status.removeAttribute("data-error");
    }
  }

  function mailtoFor(request) {
    const email = form ? form.dataset.email || "sales@chip-seek.com" : "sales@chip-seek.com";
    const subject = "Availability alert: " + (request.mpn || "part");
    const lines = [
      "Availability alert from the Chip-seek website.",
      "",
      "MPN: " + (request.mpn || ""),
      "Contact email: " + (request.email || ""),
      "Target quantity: " + (request.quantity || "Not specified"),
      "Target date: " + (request.target_date || "Not specified"),
    ];
    if (request.note) {
      lines.push("", "Additional detail:", request.note);
    }
    lines.push(
      "",
      "Please confirm current availability, lead time and commercial terms for this requirement.",
    );
    return (
      "mailto:" +
      encodeURIComponent(email) +
      "?subject=" +
      encodeURIComponent(subject) +
      "&body=" +
      encodeURIComponent(lines.join("\n"))
    );
  }

  function renderList() {
    const requests = readRequests();
    if (!list) return;
    if (!requests.length) {
      list.hidden = true;
      if (empty) empty.hidden = false;
      if (clearButton) clearButton.hidden = true;
      return;
    }
    list.hidden = false;
    if (empty) empty.hidden = true;
    if (clearButton) clearButton.hidden = false;
    list.innerHTML = requests
      .map(function (request, index) {
        return (
          '<li class="ics-alert-item" data-alert-item data-index="' + index + '">' +
          '<div class="ics-alert-item__copy">' +
          "<strong>" + escapeHtml(request.mpn || "Part") + "</strong>" +
          "<span>" +
          escapeHtml(request.email || "") +
          (request.quantity ? " · Qty " + escapeHtml(request.quantity) : "") +
          (request.target_date ? " · Target " + escapeHtml(request.target_date) : "") +
          "</span>" +
          (request.note ? "<small>" + escapeHtml(request.note) + "</small>" : "") +
          "</div>" +
          '<div class="ics-alert-item__actions">' +
          '<a class="ics-alert-item__send" href="' + escapeHtml(mailtoFor(request)) + '">Send to team</a>' +
          '<button type="button" class="ics-alert-item__remove" data-alert-remove="' + index + '">Remove</button>' +
          "</div>" +
          "</li>"
        );
      })
      .join("");
  }

  if (form) {
    form.addEventListener("submit", function (event) {
      event.preventDefault();
      if (!form.reportValidity()) {
        showStatus("Please complete the required fields before saving the request.", true);
        return;
      }

      const data = new FormData(form);
      const request = {
        mpn: String(data.get("mpn") || "").trim(),
        email: String(data.get("email") || "").trim(),
        quantity: String(data.get("quantity") || "").trim(),
        target_date: String(data.get("target_date") || "").trim(),
        note: String(data.get("note") || "").trim(),
        createdAt: new Date().toISOString(),
      };
      const requests = readRequests();
      requests.unshift(request);
      writeRequests(requests.slice(0, 50));
      renderList();
      form.reset();
      showStatus(
        "Request saved on this device. Use Send to team to notify the sourcing team, or keep it here until you are ready.",
        false,
      );
    });
  }

  if (list) {
    list.addEventListener("click", function (event) {
      const remove = event.target.closest("[data-alert-remove]");
      if (!remove) return;
      const index = Number(remove.dataset.alertRemove);
      const requests = readRequests();
      if (Number.isFinite(index) && requests[index]) {
        requests.splice(index, 1);
        writeRequests(requests);
      }
      renderList();
    });
  }

  if (clearButton) {
    clearButton.addEventListener("click", function () {
      writeRequests([]);
      renderList();
    });
  }

  renderList();
})();
